export const getChangelogsByEntityIdQuery = /* GraphQL */ `
  query GetChangelogsByEntityId($entityID: ID!) {
    changeLogByEntityID(
      entityID: $entityID
      filter: { newValue: { ne: null }, oldValue: { ne: null } }
      sortDirection: DESC
      limit: 500
    ) {
      items {
        changedBy
        entityID
        field
        id
        oldValue
        newValue
        productID
        tableName
        changedAt
      }
    }
  }
`
